import {isNullOrUndefined} from "../../../../common/utils";
import {TooltipMessage} from "../../../../common/data/TooltipMsg";
import {CloseOutlined, EditTwoTone} from "@ant-design/icons";
import {sendUserGroupDetailsEvent, UserGroupDetailsAction} from "../../../../components/matomoClient";
import {Tooltip} from "antd";

function RenderIconWithTooltip({children, tooltipMessage}) {
  return (
    <>
      <span>
        <Tooltip
          placement="top"
          title={tooltipMessage}
        >
          {children}
        </Tooltip>
      </span>
    </>
  );
}

export function specialConditionsColumnGenerator(
  IndividualInclusionMembers,
  haveMembershipConditionsEditAccess,
  propsForSpecialConditions,
  navigateToEditSpecialConditionPage,
  navigateToDeleteSpecialConditionPage,
  isIndividualInclusionNamingEnabled
) {
  const twoToneColor = "#173d4d";
  let columns = isNullOrUndefined(IndividualInclusionMembers)
    ? []
    : [
      {
        title: "Business Team members",
        dataIndex: "userName",
        key: "userName",
        render: (userName, specialConditionRecord) => {
          return (
            <div className="special-condition-member">
              <div className="special-condition-member-first-line">
                <span className="special-condition-member-name">{userName},</span>
                <span className="special-condition-member-employee-id">
                      {specialConditionRecord?.userEmployeeId}
                </span>
              </div>
              <div>{specialConditionRecord?.userEmail}</div>
            </div>
          );
        },
      },
      {
        title: "Reason",
        dataIndex: "reason",
        key: "reason",
      },
    ];

  if (haveMembershipConditionsEditAccess === true) {
    const ActionsColumnAttribute = {
      title: "Actions",
      key: "actions",
      width: "9%",
      render: (specialConditionRecord) => {
        return (
          <div className="special-condition-action-container">
            <RenderIconWithTooltip
              tooltipMessage={
                isIndividualInclusionNamingEnabled
                  ? TooltipMessage.editIndividualInclusionMemberDetails
                  : TooltipMessage.editSpecialMemberDetails
              }
            >
              <EditTwoTone
                className="icons"
                twoToneColor={twoToneColor}
                onClick={() => {
                  navigateToEditSpecialConditionPage(
                    specialConditionRecord.userId,
                    propsForSpecialConditions
                  );
                  sendUserGroupDetailsEvent(
                    UserGroupDetailsAction.EditIndividualInclusionMemberDetails,
                    TooltipMessage.editIndividualInclusionMemberDetails
                  );
                }}
              />
            </RenderIconWithTooltip>
            <RenderIconWithTooltip
              tooltipMessage={
                isIndividualInclusionNamingEnabled
                  ? TooltipMessage.deleteIndividualInclusionMember
                  : TooltipMessage.deleteSpecialMember
              }
            >
              <CloseOutlined
                className="icons"
                twoToneColor={twoToneColor}
                onClick={() => {
                  navigateToDeleteSpecialConditionPage(
                    specialConditionRecord.userId,
                    propsForSpecialConditions
                  );
                  sendUserGroupDetailsEvent(
                    UserGroupDetailsAction.DeleteIndividualInclusionMemberDetails,
                    TooltipMessage.deleteIndividualInclusionMember
                  );
                }}
              />
            </RenderIconWithTooltip>
          </div>
        );
      },
    };
    columns.push(ActionsColumnAttribute);
  }
  columns.forEach((column) => {
    if (isNullOrUndefined(column.searchEnabled)) {
      column.searchEnabled = false;
    }
    if (isNullOrUndefined(column.sortEnabled)) {
      column.sortEnabled = false;
    }
  });

  return columns;
}

